module.exports = __webpack_public_path__ + "img/lightbulb-yellow.2bf9bf57.png";